exports.Routes = {
  AuthPage: (query) => ({ pathname: "/auth", query }),
  CheckMailboxPage: (query) => ({ pathname: "/check-mailbox", query }),
  LoginPage: (query) => ({ pathname: "/login", query }),
  SignupPage: (query) => ({ pathname: "/signup", query }),
  CategoriesPage: (query) => ({ pathname: "/categories", query }),
  NewCategoryPage: (query) => ({ pathname: "/categories/new", query }),
  Page404: (query) => ({ pathname: "/404", query }),
  SubsPage: (query) => ({ pathname: "/", query }),
  EditSubPage: (query) => ({ pathname: "/subscriptions/[subId]/edit", query }),
  SubPage: (query) => ({ pathname: "/subscriptions/[subId]", query }),
  NewSubPage: (query) => ({ pathname: "/subscriptions/new", query }),
  PendingSubsPage: (query) => ({ pathname: "/subscriptions/pending", query }),
  ProfilePage: (query) => ({ pathname: "/profile", query })
}